import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { UsernameForm } from "../../../Components/molecules/AuthForms/UsernameForm";
import { ContactSupport } from "../../../Components/molecules/ContactSupport/ContactSupport";
import { AuthWrap } from "../../../Components/templates/AuthWrap/AuthWrap";
import { useAuth } from "../../../Store/AuthContext";
import useOverlayState from "../../../Utils/Hooks/useOverlayState";

export const Username = () => {
  const { state } = useAuth();
  const { t, i18n } = useTranslation(["glossary"]);
  const navigate = useNavigate();
  const { openOverlay, closeOverlay, OverlayState } = useOverlayState();
  const { dispatch } = useAuth();
  //use state to store user role name
  const [userRoleName, setUserRoleName] = useState(null);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Add a popstate event listener to handle back navigation
    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("load", handleBeforeUnload);

      // Remove the popstate event listener when the component unmounts
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);
  const handlePopstate = (event) => {
    const code = document.cookie
      .split(" ")
      .find((row) => row.startsWith("lang="))
      ?.split("=")[1];
    if (!code) {
      navigate("/signin/select-language");
    }
    const state = event.state;

    // Check if the user has reached the user name page
    if (state && state.page === "username") {
      // You can navigate to the "select-language" page when unmounting
      navigate("/signin/select-language");
    }
  };
  return (
    <AuthWrap
      pageTitle={t("glossary:auth.login-email.title")}
      pageSubheading={t("glossary:auth.login-email.subheading")}
      formWidth={"348px"}
    >
      <UsernameForm
        t={t}
        state={state}
        onClick={(status, email) => {
          //update the state of user role name
          setUserRoleName(localStorage.getItem('UserRoleName'));
          if (status === "pass") {
            // temp save email
            dispatch({
              type: "SET_VERIFIED_EMAIL",
              payload: email,
            });
            navigate("/signin/enter-otp", {
              state: {
                username: email,
              },
            });
          } else if (status === "contact-support") {
            openOverlay({ OverlayName: status });
          }
        }}
      />
      {OverlayState.visible && (
        <ContactSupport
          t={t}
          visible={OverlayState.visible}
          close={closeOverlay}
          userRoleName={userRoleName}
        />
      )}
    </AuthWrap>
  );
};
